// External globals
import { App } from '@/services/app-compat';
import { api } from '@/services/api-class';
import { hasValue, getModuleType } from '@/utils/legacy-utils';
import { Mousetrap, kstPrompt, isUWPApp, isIOSApp, isAndroidApp, isWindowsAppSdkApp } from '@/utils/window-globals';
import { ModuleType } from '@/constants/codes';
import { getCallCardTemplateConfig, isCallCardTemplateCommand, executeCallCardTemplateCommand } from '@/utils/call-card-template';

//SHORTCUT KEYS - NEED TO ADD ABILITY TO DETERMINE IF YOU ARE IN A CERTAIN MODULE

//GLOBAL QUICK KEYS    For MDT and CAD sections scroll down further ///
// Need to check to make sure user is logged in otherwise the functions shouldn't work
// currently you can change themes without being logged in

// Toggles the overflow menu on the toolbar
Mousetrap.bind('alt+m', function (e) {
    const toolbars = document.querySelectorAll('.officer-toolbar');
    for (let i = 0; i < toolbars.length; i++) {
        const el = toolbars[i] as HTMLElement;
        const ref = (el as any).__ornaToolbarRef;
        if (ref && el.offsetWidth > 0) {
            ref.toggleMenu();
            break;
        }
    }
    return false;
});

// CAD - SEND/UPDATE Call Card
Mousetrap.bind('alt+s', function (e) {
    if (App.isViewingCADPage() && isCallCardScreenLoaded() && hasValue(App.callCardController)) {
        if (hasValue(App.currentCC.id)) {
            App.callCardController!.updateCC(null);
        } else {
            App.callCardController!.sendCADCC();
        }
    }
    return false;
});

// Pulls up modal for quick keys
Mousetrap.bind('alt+a', function (e) {
    (window as any).showShortcutsModal();
    return false;
});

// User Profile
Mousetrap.bind('alt+u', function (e) {
    if (App.isViewingMDTPage()) {
        window.OrnaReact.navigate.toUserProfile('MDT');
    } else if (App.isViewingCADPage()) {
        window.OrnaReact.navigate.toUserProfile('CAD');
    } else if (App.isViewingAdminPage()) {
        window.OrnaReact.navigate.toUserProfile('ADMIN');
    }
    return false;
});

// Day Theme Picker
Mousetrap.bind('alt+1', function (e) {
    updateThemeColor(THEME_DAY_COOKIE_VALUE);
    return false;
});
// Night Theme Picker
Mousetrap.bind('alt+2', function (e) {
    updateThemeColor(THEME_NIGHT_BLUE_COOKIE_VALUE);
    return false;
});

// Night Grey Theme Picker
Mousetrap.bind('alt+3', function (e) {
    updateThemeColor(THEME_NIGHT_GREY_COOKIE_VALUE);
    return false;
});

/////////MOBILE DATA TERMINAL (MDT) QUICK KEYS ONLY/////////////
// these quick keys should be able to be used anywhere in the MDT module
// some of these quick keys are the same as CAD so we need a function to say "Stay in this module and do this function"
// Otherwise it will swap to a different module randomly if you have permissions to it

//  HOME PAGE
Mousetrap.bind('f1', function (e) {
    showHomePage()
    return false;
});

// MDT - Self Initiate & My Call
// CAD - In Progress
Mousetrap.bind('f2', function (e) {
    if (App.isViewingMDTPage()) {
        SelfInitiate();
    } else if (App.isViewingCADPage()) {
        window.OrnaReact.navigate.toInProgress('CAD');
    }
    return false;
});

// MDT - In Progress
// CAD - Officer Status
Mousetrap.bind('f3', function (e) {
    if (App.isViewingMDTPage()) {
        window.OrnaReact.navigate.toInProgress('MDT');
    } else if (App.isViewingCADPage()) {
        window.OrnaReact.navigate.toOfficerStatus('CAD');
    }
    return false;
});

// MDT - Officer Status
// CAD - New Call Card
Mousetrap.bind('f4', function (e) {
    if (App.isViewingMDTPage()) {
        window.OrnaReact.navigate.toOfficerStatus('MDT');
    } else if (App.isViewingCADPage()) {
        window.OrnaReact.navigate.toNewCallCard();
    }
    return false;
});

// Log
Mousetrap.bind('f5', function (e) {
    if (App.isViewingMDTPage()) {
        window.OrnaReact.navigate.toLog('MDT');
    } else if (App.isViewingCADPage()) {
        window.OrnaReact.navigate.toLog('CAD');
    }
    return false;
});

// Map
Mousetrap.bind('f6', function (e) {
    if (App.isViewingMDTPage()) {
        window.OrnaReact.navigate.toMap('MDT');
    } else if (App.isViewingCADPage()) {
        window.OrnaReact.navigate.toMap('CAD');
    }
    return false;
});

// Notes
Mousetrap.bind('f7', function (e) {
    if (App.isViewingMDTPage()) {
        window.OrnaReact.navigate.toNotes('MDT');
    } else if (App.isViewingCADPage()) {
        window.OrnaReact.navigate.toNotes('CAD');
    }
    return false;
});

// Search
Mousetrap.bind('f8', function (e) {
    if (App.isViewingMDTPage()) {
        window.OrnaReact.navigate.toSearch('MDT');
    } else if (App.isViewingCADPage()) {
        window.OrnaReact.navigate.toSearch('CAD');
    }
    return false;
});

// Case Reports
Mousetrap.bind('f9', function (e) {
    if (App.isViewingMDTPage()) {
        window.OrnaReact.navigate.toCaseReportList('MDT');
    }
    return false;
});

// Messaging
//check to ensure when the messaging button is on the dropdown it still works
Mousetrap.bind('f10', function (e) {
    if (App.isViewingMDTPage()) {
        window.OrnaReact.navigate.toMessaging('MDT');
    } else if (App.isViewingCADPage()) {
        window.OrnaReact.navigate.toMessaging('CAD');
    }
    return false;
});

// MDT Edit Assigned Call Quick Key is only for MDT while viewing the assigned call
Mousetrap.bind('alt+e', function (e) {
    if (App.isViewingMDTPage() && isCallCardScreenLoaded() && App.callCardController?.canEnterMDTEditMode) {
        App.callCardController.editMDTCC();
    }
    return false;
});
// MDT Self Assign Call is for MDT only while viewing the assigned call
Mousetrap.bind('alt+f1', function (e) {
    if (App.isViewingMDTPage() && isCallCardScreenLoaded()) {
        addSelfToCallCardMDT();
    }
    return false;
});

// MDT assigned call enroute - THIS SHOULD ONLY BE FOR CALLS THE OFFICER IS ASSIGNED AS AN ACTIVE CALL
// if i'm on the home screen or any other screen I should be able to press quickkey and update my times without going into the call itself
Mousetrap.bind('alt+f2', function (e) {
    //if current user is in MDT module
    if (App.isViewingMDTPage() && App.callCardController?.mdtOfficerTimeButtonsEnabled) {
        updateMdtOfficerCallTime('enroute', 'enroute', 'Enroute time updated.');
    }
    return false;
});
// MDT assigned call Onscene - THIS SHOULD ONLY BE FOR CALLS THE OFFICER IS ASSIGNED AS AN ACTIVE CALL
// if i'm on the home screen or any other screen I should be able to press quickkey and update my times without going into the call itself
Mousetrap.bind('alt+f3', function (e) {
    if (App.isViewingMDTPage() && App.callCardController?.mdtOfficerTimeButtonsEnabled) {
        updateMdtOfficerCallTime('onscene', 'onScene', 'On-scene time updated.');
    }
    return false;
});
// MDT assigned call Cleared - THIS SHOULD ONLY BE FOR CALLS THE OFFICER IS ASSIGNED AS AN ACTIVE CALL
// if i'm on the home screen or any other screen I should be able to press quickkey and update my times without going into the call itself
Mousetrap.bind('alt+f5', function (e) {
    if (App.isViewingMDTPage() && App.callCardController?.mdtOfficerTimeButtonsEnabled) {
        updateMdtOfficerCallTime('cleared', 'cleared', 'Cleared time updated.');
    }
    return false;
});

Mousetrap.bind('/', function (e) {
    if (App.isViewingCADPage()) {
        kstPrompt({
            title: 'Command Line',
            placeholder: 'Enter command...',
            submitText: 'Submit',
            inputName: 'txtCommandLine'
        }).then(function (command) {
            if (command) {
                const templateConfig = getCallCardTemplateConfig();
                if (templateConfig && isCallCardTemplateCommand(command)) {
                    executeCallCardTemplateCommand(command, templateConfig);
                } else {
                    api.submitCommand(command, (result) => {
                        App.showPopupNotification(`Command succeeded: "${command}".`, "success");
                    }, (failResult) => {
                        App.showPopupNotification(`Command failed: "${command}".`, "error");
                    });
                }
            }
        });
    }
    return false;
});


// MDT Create Report from Call Card is for MDT only while viewing the assigned call
//Mousetrap.bind('ctrl+r', function (e) {
//    if (App.isViewingMDTPage() && isCallCardScreenLoaded()) {
        
//    }
//    return false;
//});